import React, { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { useQuery } from "@apollo/client";
import { GET_NOTICES_COUNT } from "../../../../../quries/notice";
import { Redirect } from "react-router";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      widht: "100%",
      "& > *": {
        marginTop: theme.spacing(2),
      },
    },
  })
);

interface BoardPaginationProps {
  pageIndex: number;
  setPageIndex: any;
  history: any;
}

export default function BoardPagination({
  pageIndex,
  setPageIndex,
  history,
}: BoardPaginationProps) {
  const classes = useStyles();
  const [count, setCount] = useState<number | null>(null);
  const { data, loading, error } = useQuery(GET_NOTICES_COUNT, {
    fetchPolicy: "no-cache",
  });
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPageIndex(value);
    history.push(`/notice/${value}`);
    // <Redirect to={`/notice/${value}`}></Redirect>;
  };

  useEffect(() => {
    if (data && data.noticesCount) {
      let countNumber = Math.ceil(data.noticesCount / 10);

      setCount(countNumber);
    }
    return () => {
      setCount(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.noticesCount) {
    console.log(error);
  }

  return (
    <div className={classes.root}>
      {count ? (
        <Pagination
          count={count}
          // defaultPage={6}
          // boundaryCount={2}
          style={{ fontSize: 32 }}
          page={pageIndex}
          onChange={handleChange}
          color="primary"
        />
      ) : (
        <div></div>
      )}
    </div>
  );
}
